module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Bold-d625f2a1cf3aa13402e2458647a1c6ef.ttf";